"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var SearchResultsTableRow_1 = require("./SearchResultsTableRow");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var Confirmation_1 = require("../../Confirmation");
var Notification_1 = require("../../Notification");
var SearchResultsTable = /** @class */ (function (_super) {
    __extends(SearchResultsTable, _super);
    function SearchResultsTable(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.toggleDeleteUserPopup = function () {
            _this.setState(function (prevState) { return ({
                showDeleteAccountConfirmation: !prevState.showDeleteAccountConfirmation
            }); });
        };
        _this.toggleSuccessDeleteAccountNotification = function () {
            _this.setState(function (prevState) { return ({
                showSuccessDeleteAccountNotification: !prevState.showSuccessDeleteAccountNotification
            }); });
        };
        _this.state = {
            showDeleteAccountConfirmation: false,
            showSuccessDeleteAccountNotification: false
        };
        return _this;
    }
    SearchResultsTable.prototype.render = function () {
        return (this.props.customers &&
            this.props.customers.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsx)("div", { className: "col-12 table-responsive", children: (0, jsx_runtime_1.jsx)("table", { className: "table table-striped table-hover table-sm", children: this.isEmptyAccountTable(this.props.customers) ? this.renderEmptyAccountTable() : this.renderRegularAccountTable() }) }) })));
    };
    SearchResultsTable.prototype.renderSearchResultRows = function () {
        var _this = this;
        return this.props.customers.map(function (customer) { return ((0, jsx_runtime_1.jsx)(SearchResultsTableRow_1.SearchResultsTableRow, { customer: customer, logAgentActivity: _this.props.logAgentActivity }, customer.referenceNumber)); });
    };
    SearchResultsTable.prototype.renderRegularAccountTable = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col", children: "First name" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Last name" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Date of birth" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Email" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Postcode" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderSearchResultRows() })] }));
    };
    SearchResultsTable.prototype.renderEmptyAccountTable = function () {
        var _this = this;
        var emptyAccountEmail = this.props.customers[0].email;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Email" }) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", { className: "p-0", children: (0, jsx_runtime_1.jsxs)("span", { className: "text-decoration-none d-inline-flex px-3 py-3", children: [emptyAccountEmail, this.supportPortalTemplates.userHasRole(["Administrator", "CSR_Lead", "CSR"]) && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("i", { title: "Delete empty account", className: "icon-button fas fa-user-times ml-2", id: "deleteEmptyAccount", onClick: this.toggleDeleteUserPopup, role: "none" }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showDeleteAccountConfirmation, hide: this.toggleDeleteUserPopup, confirm: function () { return _this.deleteUserByEmail(emptyAccountEmail); }, title: "Are you sure?", message: "Are you sure you want to delete the account for - ".concat(emptyAccountEmail, " ?") }), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showSuccessDeleteAccountNotification, hide: function () {
                                                    _this.toggleSuccessDeleteAccountNotification();
                                                    _this.props.search();
                                                }, title: "Success!", message: "Successfully deleted the account for - ".concat(emptyAccountEmail) })] }))] }) }) }) })] }));
    };
    SearchResultsTable.prototype.isEmptyAccountTable = function (customers) {
        return customers.length === 1 && customers[0].deletable;
    };
    SearchResultsTable.prototype.deleteUserByEmail = function (email) {
        var _this = this;
        this.supportPortalService
            .deleteIdentityUserByEmail(email)
            .subscribe(function (response) {
            if (!(response instanceof Error)) {
                _this.toggleSuccessDeleteAccountNotification();
            }
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], SearchResultsTable.prototype, "supportPortalService", void 0);
    SearchResultsTable = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], SearchResultsTable);
    return SearchResultsTable;
}(React.Component));
exports.SearchResultsTable = SearchResultsTable;
//# sourceMappingURL=SearchResultsTable.js.map